import { useState, useEffect } from "react";
import { Route, Routes, useParams } from "react-router";

import Loading from "components/Tools/Loading";
import BookingPage from "./BookingPage";
import AddGuestPage from "./AddGuestPage";
import SuccessPage from "./SuccessPage";
import mainStore from "store/mainStore";
import proxy from "api/proxy";
import func from "tools/functions";
import fields from "./fields";
import Header from "../layout/Header";
import Footer from "pages/Footer";

function WebCheckIn(props) {
  const { id } = useParams();
  const [booking, setBooking] = useState(null);
  const { reset } = mainStore();

  function onAddGuest() {
    getBooking();
  }

  async function getBooking() {
    if (!id) {
      return;
    }
    const dom = [["id", "=", id]];
    const { data } = await proxy.search("hotel.booking", dom, fields);
    const { data: config } = await proxy.search(
      "hotel.configuration",
      [],
      ["link_melhous"],
    );

    if (data) {
      const record = func.prepareRecord(data[0]);
      const _record = {
        link_melhous: config?.[0]?.link_melhous,
        ...record,
      };
      setBooking(_record);
    }
  }

  useEffect(() => {
    getBooking();
    reset();
  }, [props]);

  if (!booking) {
    return <Loading />;
  }

  return (
    <div className="bg-[#F8F9FC] w-full min-h-screen">
      <Header />
      <main className="my-[36px] mx-auto w-full">
        <Routes>
          <Route path="/" element={<BookingPage booking={booking} />} />
          <Route path="folio" element={<AddGuestPage onAdd={onAddGuest} />} />
          <Route path="success" element={<SuccessPage booking={booking} />} />
        </Routes>
      </main>
      <Footer style="bg-gradient-to-t- from-neutral-900 from- via-neutral-900 via- to-neutral-800/90 to-" />
    </div>
  );
}

export default WebCheckIn;
